import React from "react";
// import Slider from "react-slick";
import SubscriptionCard from "./SubscriptionCard";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import "../Pricing.css";
import colors from "../../../../Constants/colors";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import theme from "../../../../Constants/theme";
const SubscriptionCarousel = ({ cards, setPlan, handleSubscribe, plan }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    appendDots: (dots) => (
      <div
        style={{
          padding: "10px 0 0 0",
        }}
      >
        <ul style={{ marginTop: "10px" }}>{dots}</ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          width: "6px",
          height: "6px",
          backgroundColor: colors.extremeWhite,
          borderRadius: "50%",
          display: "inline-block",
        }}
      />
    ),
  };

  const muiTheme = useTheme();
  const isSmDown = useMediaQuery(muiTheme.breakpoints.down("sm"));
  const isMdDown = useMediaQuery(muiTheme.breakpoints.down("md"));

  const getGridSize = () => {
    if (isSmDown) return 12;
    if (isMdDown) return 6;
    return 4; // Show 3 per row by default
  };

  return (
    <Box
      sx={{
        width: "100%",
        py: 4,
        px: 2,
      }}
    >
      <Grid container spacing={2} justifyContent="center">
        {cards.map((card, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <SubscriptionCard
              title={card.title}
              price={card.price}
              buttonText={card.buttonText}
              features={card.features}
              setPlan={setPlan}
              handleSubscribe={handleSubscribe}
              plan={plan}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
export default SubscriptionCarousel;
